import { defineStore } from 'pinia';

const useStore = defineStore('main', {
  state: () => ({
    advSearchQuery: '',
    advSearchCheckbox: [],
    advSearchTags: [],
    advSearchOperator: '',
    advSearchCurrentTab: 'free_text_tab',
    advSearchImgTblOpt: '',
  }),
  persist: true,
});
export default useStore;
